module.exports = __webpack_public_path__ + "img/mysql-logo.fc52c025.png";